import styles from "./CallNotesCell.module.scss";

export const renderCallNotes = (value: unknown) => (
	<span className={styles.callNotes}>
		{value == null || value === "" ? "—" : String(value)}
	</span>
);
